'use es6';

import { combineReducers } from 'redux';
import { APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE, APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE, APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_ERROR, APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_DEMO_ERRORS, FETCH_ATTRIBUTES_META, RECEIVE_ATTRIBUTES_META } from 'DesignData/actions/ActionTypes';
import { DEFAULT_IS_ENABLED, DEFAULT_CONFIG } from 'DesignData/constants/settings/ESLint';
import { EMPTY_OBJECT } from 'DesignData/lib/object';
import { EMPTY_ARRAY } from 'DesignData/lib/array';
/**
 * @type {Boolean}
 */

function isEnabled(state = DEFAULT_IS_ENABLED, action) {
  switch (action.type) {
    case APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE:
      {
        return action.data.isEnabled;
      }

    case FETCH_ATTRIBUTES_META:
    case RECEIVE_ATTRIBUTES_META:
      {
        const {
          isEnabled: enabled
        } = action.designManagerUserSettings.javaScriptLinter || EMPTY_OBJECT;
        return enabled === !!enabled ? enabled : state;
      }

    default:
      return state;
  }
}
/**
 * @type {String} JSON
 */


function eslintConfig(state = DEFAULT_CONFIG, action) {
  switch (action.type) {
    case APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE:
      {
        return action.data.eslintConfig;
      }

    case FETCH_ATTRIBUTES_META:
    case RECEIVE_ATTRIBUTES_META:
      {
        const {
          eslintConfig: config
        } = action.designManagerUserSettings.javaScriptLinter || EMPTY_OBJECT;
        return config && typeof config === 'string' ? config : state;
      }

    default:
      return state;
  }
}
/**
 * @type {CodeEditorError}
 */


function eslintConfigError(state = null, action) {
  switch (action.type) {
    case APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_ERROR:
      {
        return action.error || null;
      }

    default:
      return state;
  }
}
/**
 * @type {Array.<CodeEditorError>}
 */


function eslintDemoErrors(state = EMPTY_ARRAY, action) {
  switch (action.type) {
    case APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_DEMO_ERRORS:
      return action.data.errors;

    default:
      return state;
  }
}

export default combineReducers({
  isEnabled,
  eslintConfig,
  eslintConfigError,
  eslintDemoErrors
});